import axios from 'axios'
import Moment from 'moment'
import React, { useEffect, useState } from 'react'
import authService from '../Components/Login/auth.service'
import * as TypIcons from 'react-icons/ti'
import { Link, useNavigate } from 'react-router-dom'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  TitlePage3
} from '../Components/Main'
import '../styles/pages/pessoas.css'
import Modal from './MenuDireito/MenuDireito-Modal/ModalCadPessoa'
import ModalEditar from './MenuDireito/MenuDireito-Modal/ModalEdiPessoa'
import padrao from '../Components/profile.png'
import ProfileDireita from '../Components/ProfileDireita'
import { NavDireita } from '../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../Components/SideBar-right/SidebarMobile'

function Pessoas() {
  var user = authService.getCurrentUser()
  const [pessoas, setPessoas] = useState<any[]>([])
  const [modalInfo, setModalInfo] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/pessoa/list/' +
          user[0].IdEmpresa +
          '/' +
          sessionStorage.IdUnidade
      )
      .then(response => {
        setPessoas(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }

  const [modalOpen, setModalOpen] = useState(false)
  const history = useNavigate()

  return (
    <div className="displayInteract">
      {modalOpen && (
        <ModalEditar setOpenModal={setModalOpen} modalInfo={modalInfo} />
      )}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <button
          className="btnReturn"
          type="button"
          onClick={() => history(-1)}
        >
          <TypIcons.TiArrowBackOutline />
        </button>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>{sessionStorage.uniRazaoSocial} / PESSOAS</TitlePage1>
            {/* <TitlePage2>Gerentes/Operadores</TitlePage2> */}
          </TitleOfPage>

          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />

            <Modal />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>
                <p className="ttlTbl">Nome</p>{' '}
              </th>
              <th>
                {' '}
                <p className="ttlTbl">E-Mail/login</p>
              </th>
              <th>
                {' '}
                <p className="ttlTbl">Função </p>
              </th>
              <th>
                {' '}
                <p className="ttlTbl">Web </p>
              </th>
              <th>
                {' '}
                <p className="ttlTbl">App </p>
              </th>
              <th>
                {' '}
                <p className="ttlTbl">Ativo </p>
              </th>
              {/* <th >Metas</th> */}
              <th>
                Registro /
                <br /> Atualização
              </th>
            </thead>
            <tbody>
              {pessoas
                .filter(val => {
                  if (searchTerm === '') {
                    return val
                  } else if (
                    val.pesNome
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    val.pesEmail
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    val.fncDescricao
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(pessoa => (
                  <tr
                    onClick={() => handleToggleComplete(pessoa)}
                    key={pessoa.IdPessoa}
                  >
                    <td>{pessoa.pesNome}</td>
                    <td>{pessoa.pesEmail}</td>
                    <td>{pessoa.fncDescricao}</td>
                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!pessoa.pesAcessoWeb}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>

                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!pessoa.pesAcessoApp}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>

                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!pessoa.pesStatus}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>
                      <p className="SpaceDate">
                        {Moment(pessoa.pesAlteradoEm).format('DD/MM/YYYY')}
                      </p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>

      <nav className="mostrarFiltro">
        <ProfileDireita />
      </nav>
    </div>
  )
}

export default Pessoas
